// @flow
import type { UnauthSeoExperiments } from 'app/common/lib/react/withUnauthSeoExperiments';
import UNAUTH_PAGE_TYPE from 'app/common/react/components/growth/unauth/lib/UnauthPageType';
import { HybridTiers } from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';

// In modal variant: height = width
export const EDUCATION_VIDEO_IN_MODAL_HEIGHT = 398;
export const EDUCATION_VIDEO_IN_MODAL_WIDTH = 708;

// In modal variant: aligh height due to different modal (signup/login) height
export const EDUCATION_VIDEO_IN_MODAL_SMALL_HEIGHT = 460;
export const EDUCATION_VIDEO_IN_MODAL_MEDIUM_HEIGHT = 560;
export const EDUCATION_VIDEO_IN_MODAL_MARGIN = 3;

export const EDUCATION_VIDEO_IN_PIN_GRID_WIDTH = 708;
export const EDUCATION_VIDEO_IN_PIN_GRID_HEIGHT = 398;
export const EDUCATION_VIDEO_IN_PIN_GRID_COMPONENT_HEIGHT = 480;
export const EDUCATION_VIDEO_IN_PIN_GRID_FIRST_SECTION_PIN_NUMBER = 6;

// In Pin Grid variant: Height is different due to different window width
export const EDUCATION_VIDEO_IN_PIN_GRID_NARROW_WINDOW_COMPONENT_HEIGHT = 500;
export const EDUCATION_VIDEO_FOLD_WIDTH = 1150;
export const EDUCATION_VIDEO_SCROLL_THRESHOLD = 800;

const EducationVideoExperimentUtils = (
  seoUnauthExperiments: UnauthSeoExperiments,
  eligibleExperiences: {},
  pageType: string = '',
  isInModal?: boolean = false,
  hybridTier: string = '',
  isBot: boolean,
) => {
  if (pageType === UNAUTH_PAGE_TYPE.PIN && hybridTier === HybridTiers.tier1 && !isBot) {
    // Check experience is eligible (pre-check for cooldown cases)
    if (
      !!(
        eligibleExperiences[PCONST.thrift.Placement.UNAUTH_WEB_PIN_PAGE_TAKEOVER] &&
        eligibleExperiences[PCONST.thrift.Placement.UNAUTH_WEB_PIN_PAGE_TAKEOVER].experience_id ===
          PCONST.thrift.Experience.WEB_UNAUTH_PLP_EDUCATION_VIDEO
      )
    ) {
      const educationVideoExperiment =
        seoUnauthExperiments.v2GetGroup('web_unauth_plp_education_video') || '';
      return educationVideoExperiment.startsWith('enabled');
    }
  }

  return false;
};

export default EducationVideoExperimentUtils;
